import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  padding: 20px;
  background: #eff5f7;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  color: black;
  p{
      padding: 10px 0px;
      font-size: 18px;
      text-align: center;
  }
`